import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./AddImagesModalSkeleton.module.css";

const SKELETON_ROWS = 3;

export const AddImagesModalSkeleton = () => {
  return (
    <div className={styles["wrapper"]}>
      {Array.from({ length: SKELETON_ROWS }, (_, i) => (
        <div key={i} className={styles["row"]}>
          <FixaSkeleton height="24px" width="24px" />
          <FixaSkeleton height="70px" width="70px" />
          <FixaSkeleton height="16px" width="100%" />
          <div className={styles["buttonGroup"]}>
            <FixaSkeleton height="32px" width="32px" />
            <FixaSkeleton height="32px" width="32px" />
          </div>
        </div>
      ))}
    </div>
  );
};
